import { useActivityBuilderTheme } from 'approot/activity-builder/theme/activity-builder-theme';
import { useMultipleChoiceUpdate } from '../settings/multiple-choice-settings.hooks';
import {
  generateTextFieldKey,
  updateOptionText,
} from '../settings/multiple-choice-settings.utils';
import { useInputFieldState } from '../../component.hooks';
import {
  canShowOptionLetter,
  getOptionsPerColumn,
} from '../multiple-choice.utils';
import { EditProps, MultipleChoiceOption } from '../multiple-choice.constants';
import { MultipleChoiceLetter } from '../multiple-choice';
import * as Styled from '../multiple-choice-edit.style';
import MultipleChoiceEditTextField from './multiple-choice-edit-text-field';
import { LANGUAGE_CODE_EN_AU } from 'global/constants';

type Props = EditProps & {
  index: number;
  option: MultipleChoiceOption;
};

const MultipleChoiceEditText = ({
  properties,
  subActivityProperties,
  suggestedAnswerProperties,
  sectionId,
  id,
  type,
  sort,
  index,
  option,
  version,
}: Props) => {
  const { theme } = useActivityBuilderTheme();

  const { __typename, ...restProperties } = properties.multipleChoice;
  const options = restProperties.options;

  const { handleUpdate } = useMultipleChoiceUpdate({
    id,
    sectionId,
    type,
    sort,
    properties,
    subActivityProperties,
    suggestedAnswerProperties,
    language: LANGUAGE_CODE_EN_AU,
    version,
  });

  const { setEditorStateToUpdate } = useInputFieldState<string>({
    onChange: data => {
      if (option.itemId) {
        handleUpdate({
          ...properties,
          multipleChoice: {
            ...properties.multipleChoice,
            options: updateOptionText(options, option.itemId, data),
          },
        });
      }
    },
  });

  return (
    <Styled.MultipleChoiceEditBox
      $isText
      $itemsPerRow={getOptionsPerColumn(properties.multipleChoice)}
      $minHeight={properties.multipleChoice.optionMinHeight || 80}
    >
      <Styled.MultipleChoiceEditBoxContent data-selector="multiple-choice-options">
        <Styled.MultipleChoiceTextContent>
          {canShowOptionLetter(properties.multipleChoice.showOptionLetter) && (
            <MultipleChoiceLetter
              data-selector="multiple-choice-letter"
              index={index}
            />
          )}
          <MultipleChoiceEditTextField
            key={generateTextFieldKey(theme.font.medium.size, properties)}
            index={index}
            text={option.text}
            onChange={value => setEditorStateToUpdate(value)}
          />
        </Styled.MultipleChoiceTextContent>
      </Styled.MultipleChoiceEditBoxContent>
    </Styled.MultipleChoiceEditBox>
  );
};

export default MultipleChoiceEditText;
